import React, { FunctionComponent } from 'react';

const AnonymousLayout: FunctionComponent = ({children}) => {
  return <div className="AnonymousLayout">{children}</div>;
};

export default AnonymousLayout;
